// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__26Enw","productName":"Table_productName__3PiTj"};